import React from 'react';

const Download = () => (
    <svg height="14" viewBox="0 0 13 14" width="13" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd" transform="translate(1.5 1.5)">
            <path
                d="m.08578644 1.5 1.41421356-1.41421356 4.41421356 4.41421356-4.41421356 4.41421356-1.41421356-1.41421356 2.00595857-2.00581578.02792361-1.96044681z"
                fill="#0852e0"
                fillRule="nonzero"
                transform="matrix(0 1 -1 0 9.5 2.9)"
            />
            <g stroke="#0852e0" strokeLinecap="square" strokeWidth="2">
                <path d="m5 0v6" />
                <path d="m0 11h10" />
            </g>
        </g>
    </svg>
);
export default Download;
